import { ValImage } from '@valbuild/next';
import React, { useRef } from 'react';
import { ImageFeedItem } from './utils';

function FadeInImage({
  imageFeedItem,
  index,
  onImageClick,
  isPriority,
  breakpointColumnsObject,
}: {
  imageFeedItem: ImageFeedItem;
  index: number;
  onImageClick: (index: number) => void;
  isPriority: boolean;
  breakpointColumnsObject: {
    default: number;
    800: number;
  };
}) {
  const imageRef = useRef(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100');
          observer.unobserve(entry.target);
        }
      });
    });

    const currentRef = imageRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <ValImage
      ref={imageRef}
      key={index}
      className={`object-contain cursor-pointer mx-auto mb-4 ${imageFeedItem.rotate} opacity-0 transition-opacity duration-300 ease-in`}
      src={imageFeedItem.image}
      alt={imageFeedItem.image?.alt || 'På innsiden av Blank'}
      priority={isPriority}
      onClick={() => onImageClick(index)}
      sizes={`(max-width: 800px) calc((${100}vw - 20px)/${
        breakpointColumnsObject[800]
      }) - 4px), calc((${100}vw - 20px)/${
        breakpointColumnsObject.default
      }) - 4px)`} // Subtract 20px for Logo side banner, divide by number of columns and subtract 4px padding
    />
  );
}

export { FadeInImage };
